import { Tag, Text } from '@chakra-ui/react';
import classNames from 'classnames';

import styles from './CircularBadge.module.css';

interface CircularBadgeProps {
  value: number | string;
  size?: 'sm' | 'md' | 'lg';
  colorScheme?: string;
}

export const CircularBadge = ({ value, size = 'sm' }: CircularBadgeProps) => {
  const badgeSizeClass = {
    sm: styles.badgeSmall,
    md: styles.badgeMedium,
    lg: styles.badgeLarge,
  };

  const textSizeClass = {
    sm: styles.textSmall,
    md: styles.textMedium,
    lg: styles.textLarge,
  };

  return (
    <Tag
      size="xs"
      background="gray.100"
      borderRadius="100"
      padding="0 6px"
      variant="subtle"
      margin={0}
      className={classNames(styles.badge, badgeSizeClass[size])}
    >
      <Text fontSize="10" color="navyBlue.500" className={textSizeClass[size]}>
        {value}
      </Text>
    </Tag>
  );
};
